import React from 'react';
import styled from 'styled-components';
50

const Picture = ({ src, webp, altText, png, gif }) => {
    const StyledImage = styled.img`
        height: auto;
        width: auto;
        max-width: 100%;
    `;

    return (
        <picture>
            {webp ? null : <source srcSet={webp} type='image/webp' />}
            {gif ? null : <source srcSet={gif} type='image/gif' />}
            <StyledImage src={src} alt={altText || 'image'} />
        </picture>
    );
};

export default Picture;



// WEBPACK FOOTER //
// ./src/components/image/Picture.js